import React, { useState, useRef, useEffect } from 'react';
import { Transformer } from 'markmap-lib';
import { Markmap } from 'markmap-view';
// import { Toolbar } from "markmap-toolbar"
// import "markmap-toolbar/dist/style.css"

const transformer = new Transformer();
const initValue = `# markmap

// - beautiful
// - useful
// - easy
// - interactive
// `;

// function renderToolbar(mm, wrapper) {
//   while (wrapper?.firstChild) wrapper.firstChild.remove()
//   if (mm && wrapper) {
//     const toolbar = new Toolbar()
//     toolbar.attach(mm)
//     // Register custom buttons
//     toolbar.register({
//       id: "alert",
//       title: "Click to show an alert",
//       content: "Alert",
//       onClick: () => alert("You made it!")
//     })
//     toolbar.setItems([...Toolbar.defaultItems, "alert"])
//     wrapper.append(toolbar.render())
//   }
// }

export default function MarkmapHooks({ response }) {
    const [value, setValue] = useState(response);
    // Ref for SVG element
    const refSvg = useRef();
    // Ref for markmap object
    const refMm = useRef();
    // Ref for toolbar wrapper
    const refToolbar = useRef();

    useEffect(() => {
        // Create markmap and save to refMm
        console.log(response);
        const mm = Markmap.create(refSvg.current);
        refMm.current = mm;
        // renderToolbar(refMm.current, refToolbar.current)
    }, []);
    // [refSvg.current]

    useEffect(() => {
        // Update data for markmap once value is changed
        const mm = refMm.current;
        if (!mm) return;
        const { root } = transformer.transform(response);
        mm.setData(root);
        mm.fit();
    }, []);
    // [refMm.current, value]

    // const handleChange = e => {
    //   setValue(e.target.value)
    // }

    return (
        // <React.Fragment>
        // {/* <div className="">
        //   <textarea
        //     className="w-full h-full border border-gray-400"
        //     value={value}
        //     onChange={handleChange}
        //   />
        // </div> */}
        <svg style={{ height: 300, width: 1920, display: 'block' }} ref={refSvg} />
        // {/* <div className="bottom-1 right-1" ref={refToolbar}></div> */}
        // {/* </React.Fragment> */}
    );
}
